import { render, staticRenderFns } from "./BeforeProperty.vue?vue&type=template&id=a31c2b52&scoped=true&"
import script from "./BeforeProperty.vue?vue&type=script&lang=js&"
export * from "./BeforeProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a31c2b52",
  null
  
)

export default component.exports